import React, { useState } from 'react'
import Tabs, { TabPanel, TabTrigger, TabTriggerGroup } from '@zera-admin/tabs'
import { Column, Row } from '@zera-admin/page'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { string } from '@zera-admin/helpers'

import { getFieldOptions } from 'bi-tool/visualizations/visualization/getters'

import * as Styled from './NewsDefinitions.styled'
import { NEWS_FIELDS } from './constants'
import { NewsDefinitionsProps } from './types'

const NewsDefinitions: React.FunctionComponent<NewsDefinitionsProps> = ({
  fields,
  onChange,
  options,
}) => {
  const [fieldOptions, setFieldOptions] = useState<SelectOptionProps[]>(
    getFieldOptions(fields)
  )

  const handleChangeFieldInput = (value: string) => {
    const option = {
      label: value,
      value,
    }
    const index = fieldOptions.findIndex(
      (reference) => reference.value === parseInt(option.value)
    )
    let optionsInstance = [...fieldOptions]

    if (value && index === -1) {
      optionsInstance[0] = option
    } else {
      optionsInstance = getFieldOptions(fields)
    }

    setFieldOptions(optionsInstance)
  }

  const renderTabs = () => {
    return (
      <Tabs id="tabs">
        <TabTriggerGroup>
          <TabTrigger>Veri </TabTrigger>
        </TabTriggerGroup>
        <TabPanel>{renderDataTab()}</TabPanel>
      </Tabs>
    )
  }

  const renderDataTab = () => {
    const values = options?.fields || {}

    return NEWS_FIELDS.map((newsField, index) => (
      <Row key={index} xs={{ direction: 'column' }}>
        <Column>
          <Select
            name={newsField.value}
            options={fieldOptions}
            onChange={(props) => {
              onChange({
                ...options,
                fields: {
                  ...options.fields,
                  [newsField.value]: (props as SelectOptionProps)
                    .value as string,
                },
              })
            }}
            onInputChange={handleChangeFieldInput}
            value={
              values[newsField.value]
                ? {
                    label: string.textify(values[newsField.value]),
                    value: values[newsField.value],
                  }
                : { label: '', value: '' }
            }
            label={newsField.label}
            placeholder="Seçim yapınız"
          />
        </Column>
      </Row>
    ))
  }

  return <Styled.NewsDefinitions>{renderTabs()}</Styled.NewsDefinitions>
}

export default NewsDefinitions
